(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-price-offer-modular"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('bs:variant',function(event){const variant=event.detail;if(!variant)return;const price=document.getElementById('bs-modular-price');const compare=document.getElementById('bs-modular-compare');const offer=document.getElementById('bs-modular-offer-price');if(price)price.textContent=variant.priceFormatted;if(offer)offer.textContent=variant.priceFormatted;if(compare){compare.textContent=variant.referenceFormatted||'';compare.hidden=!variant.referenceFormatted}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-product-actions-modular"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const control=event.target.closest('[data-qty]');if(!control)return;const input=document.getElementById('bs-modular-quantity');const hidden=document.getElementById('bs-modular-form-quantity');if(!input||!hidden)return;const next=Math.min(10,Math.max(1,Number(input.value||1)+Number(control.dataset.qty)));input.value=next;hidden.value=next});
document.addEventListener('input',function(event){if(event.target.id!=='bs-modular-quantity')return;const hidden=document.getElementById('bs-modular-form-quantity');if(hidden)hidden.value=Math.min(10,Math.max(1,Number(event.target.value||1)))});
document.addEventListener('bs:variant',function(event){const input=document.getElementById('bs-modular-variant-id');const button=document.querySelector('.bs-actions__atc');if(input)input.value=event.detail.id;if(button)button.disabled=!event.detail.available});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-product-gallery-modular"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.bs-gallery__thumb');if(!button)return;const gallery=button.closest('.bs-module--gallery');if(!gallery)return;gallery.querySelectorAll('.bs-gallery__thumb').forEach(item=>item.classList.remove('is-active'));button.classList.add('is-active');const image=gallery.querySelector('#bs-gallery-main');const video=gallery.querySelector('#bs-gallery-video');if(button.dataset.video){if(image)image.style.display='none';if(video)video.classList.add('is-active')}else{if(video){video.classList.remove('is-active');const player=video.querySelector('video');if(player)player.pause()}if(image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.setAttribute('src',button.dataset.image);image.setAttribute('alt',button.dataset.alt||'');image.style.display='block'}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-sticky-purchase-modular"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const action=event.target.closest('[data-sticky-action]');if(!action)return;const form=document.getElementById('bs-modular-product-form');if(!form)return;if(action.dataset.stickyAction==='cart'){const button=form.querySelector('[name="add"]');if(button)button.click()}else{const buy=form.querySelector('.shopify-payment-button__button');if(buy)buy.click();else form.scrollIntoView({behavior:'smooth',block:'center'})}});
document.addEventListener('bs:variant',function(event){const price=document.getElementById('bs-sticky-price');if(price)price.textContent=event.detail.priceFormatted});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-variant-selector-modular"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const card=event.target.closest('.bs-variants__card');if(!card||card.disabled)return;document.querySelectorAll('.bs-variants__card').forEach(item=>item.classList.remove('is-active'));card.classList.add('is-active');const detail={id:card.dataset.id,priceFormatted:card.dataset.price,referenceFormatted:card.dataset.reference,available:card.dataset.available==='true'};window.BerrystoneVariant=detail;document.dispatchEvent(new CustomEvent('bs:variant',{detail:detail}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
